import { render, staticRenderFns } from "./AccountHandlersModal.vue?vue&type=template&id=c9747020&"
import script from "./AccountHandlersModal.vue?vue&type=script&lang=js&"
export * from "./AccountHandlersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports